module.exports = __webpack_public_path__ + "static/media/sales-stream-flame.f0afd08a.svg";